"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ifElse;
exports.execIfFunc = void 0;
var execIfFunc = exports.execIfFunc = function execIfFunc(x) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  return typeof x === 'function' ? x.apply(void 0, args) : x;
};

/**
 * This is a higher order function that accepts a boolean condition and will
 * return a function allowing you to provide if/else values that should be
 * resolved based on the boolean condition.
 *
 * @param  {Boolean|() => Boolean} condition:
 *   The condition to test against. This can be a function for lazy resolution.
 *
 * @return {(X|() => X, Y|() => Y) => X|Y}
 *   A function where the first paramater is the "if" and the second paramater
 *   is the "else".  Each of these allows lazy resolving by providing a function.
 *
 * @example
 *   const ifDev = ifElse(process.env.NODE_ENV === 'development');
 *   ifDev('foo', () => 'lazy resolved');  // => 'foo'
 */
function ifElse(condition) {
  return function (then, or) {
    return execIfFunc(condition) ? execIfFunc(then) : execIfFunc(or);
  };
}